import { Pipe, PipeTransform } from '@angular/core';
import { formatPhone } from '../utils/phone-utils';

/**
 * Formats a phone number to (XXX)-XXX-XX-XX display format.
 *
 * @example
 *   {{ '5551234567' | phoneFormat }}  →  (555)-123-45-67
 *   {{ parent.phone | phoneFormat }}  →  (555)-123-45-67
 */
@Pipe({
  name: 'phoneFormat',
})
export class PhoneFormatPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return formatPhone(value);
  }
}
